import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {TrackingEvent} from '@common/tracking-events'
import {Tracking} from '../../../common/tracking'
import {setDisplayName} from '../../../common/utils-ui'
import {BillingProps} from './billing-base'
import {BillingPayCard} from './billing-pay-card'
import {BillingPayInvoice} from './billing-pay-invoice'

export const BillingPay = (props: BillingProps) => {
  const {license, onChange} = props
  if (!license.type) {
    return null
  }

  const bem = Util.bemFrom('billing')
  const methodChange =
    (method: BillingProps['license']['paymentMethod']) => () => {
      void Tracking.send(TrackingEvent.billingChangeLicenseClick)
      onChange({...license, paymentMethod: method})
    }
  return (
    <div className={bem('section')}>
      <div className={bem('medium')}>{Lang.msg.billingOpts}</div>
      <div className={bem('pay-opts')}>
        <div
          className={bem('pay-opt', {
            chosen: license.paymentMethod === 'card'
          })}
          onClick={methodChange('card')}
        >
          {Lang.msg.billingCardOpt}
          <div className={bem('card')} />
        </div>
        <div
          className={bem('pay-opt', {
            chosen: license.paymentMethod === 'invoice'
          })}
          onClick={methodChange('invoice')}
        >
          {Lang.msg.billingInvoiceOpt}
        </div>
      </div>

      <div className={bem('pay-container')}>
        <BillingPayCard {...props} />
        <BillingPayInvoice {...props} />
      </div>
    </div>
  )
}
setDisplayName(BillingPay, 'BillingPay')
